/*!
 * GHAMANDI SHERR V13
 * Luxury Spotlight Engine
 */

document.addEventListener("DOMContentLoaded", () => {

    const store = document.querySelector(".gs-dynamic-store");
    if (!store) return;

    // Create spotlight
    const light = document.createElement("div");
    light.className = "gs-v13-spotlight";

    Object.assign(light.style, {
        position: "absolute",
        width: "650px",
        height: "650px",
        borderRadius: "50%",
        pointerEvents: "none",
        left: "0",
        top: "0",
        transform: "translate(-50%,-50%)",
        background:
            "radial-gradient(circle, rgba(255,255,255,.12) 0%, rgba(212,173,84,.08) 28%, rgba(212,173,84,0) 72%)",
        mixBlendMode: "screen",
        filter: "blur(40px)",
        opacity: ".9",
        transition: "opacity .4s ease",
        zIndex: "2"
    });

    store.appendChild(light);

    let mouseX = 0;
    let mouseY = 0;

    let x = 0;
    let y = 0;

    function animate() {

        x += (mouseX - x) * 0.08;
        y += (mouseY - y) * 0.08;

        light.style.left = x + "px";
        light.style.top = y + "px";

        requestAnimationFrame(animate);
    }

    animate();

    store.addEventListener("mousemove", e => {

        const rect = store.getBoundingClientRect();

        mouseX = e.clientX - rect.left;
        mouseY = e.clientY - rect.top;

    });

    store.addEventListener("mouseenter", () => {

        light.style.opacity = ".9";

    });

    store.addEventListener("mouseleave", () => {

        light.style.opacity = "0";

    });

});